var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F0F0F0"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M511.991,255.259h-277.51c-55.097,55.098-88.415,97.635-122.435,131.655l144.696,13.04 l224.534-22.261C500.871,341.498,512,300.049,512,256C512,255.752,511.991,255.507,511.991,255.259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M112.047,132.824h368.412C436.921,53.656,352.731,0,256,0C185.495,0,121.659,28.511,75.364,74.624 L112.047,132.824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M123.177,377.693c-23.014,23.014-31.908,42.296-48.559,58.946C120.973,483.186,185.118,512,256,512 c97.336,0,181.98-54.325,225.277-134.307L123.177,377.693L123.177,377.693z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6DA544"
    },
    d: "M74.98,74.239c-99.974,99.974-99.974,262.065,0,362.04c41.313-41.313,81.046-81.046,181.02-181.02 L74.98,74.239z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M67.525,255.259c0-37.298,26.213-68.457,61.217-76.101c-5.38-1.175-10.962-1.812-16.696-1.812 c-43.031,0-77.913,34.882-77.913,77.913s34.882,77.913,77.913,77.913c5.733,0,11.315-0.637,16.696-1.812 C93.738,323.715,67.525,292.557,67.525,255.259z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "127.883,188.476 132.028,201.23 145.438,201.23 134.588,209.113 138.733,221.867  127.883,213.985 117.033,221.867 121.178,209.113 110.328,201.23 123.738,201.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "127.883,221.867 132.028,234.622 145.438,234.622 134.588,242.504 138.733,255.259  127.883,247.376 117.033,255.259 121.178,242.504 110.328,234.622 123.738,234.622  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "127.883,255.259 132.028,268.013 145.438,268.013 134.588,275.896 138.733,288.65  127.883,280.767 117.033,288.65 121.178,275.896 110.328,268.013 123.738,268.013  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "127.883,288.65 132.028,301.404 145.438,301.404 134.588,309.287 138.733,322.041  127.883,314.159 117.033,322.041 121.178,309.287 110.328,301.404 123.738,301.404  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKm);
export default __webpack_public_path__ + "static/media/km.1d0b517f22d5aa12943d3a4822b231f8.svg";
export { ForwardRef as ReactComponent };